import { render, staticRenderFns } from "./AccommodationRequestsGrid.vue?vue&type=template&id=413ba7c2"
import script from "./AccommodationRequestsGrid.vue?vue&type=script&lang=js"
export * from "./AccommodationRequestsGrid.vue?vue&type=script&lang=js"
import style0 from "./AccommodationRequestsGrid.vue?vue&type=style&index=0&id=413ba7c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports